import {
  LogIn,
  LogOut,
  User,
  UserPlus,
  Wrench,
} from '@holistic/components/icons';

export type DropdownItem = {
  label: string;
  href?: string;
  onClick?: () => void;
  icon: React.ComponentType<{ size?: number }>;
  variant?: 'default' | 'destructive';
};

export const guestItems: DropdownItem[] = [
  { label: 'Giriş Yap', href: '/login', icon: LogIn },
  { label: 'Kayıt Ol', href: '/register', icon: UserPlus },
];

export const getAuthenticatedItems = (onLogout: () => void): DropdownItem[] => [
  { label: 'Profilim', href: '/profilim', icon: User },
  { label: 'Tamir Taleplerim', href: '/profilim/taleplerim', icon: Wrench },
  {
    label: 'Çıkış Yap',
    icon: LogOut,
    onClick: onLogout,
    variant: 'destructive',
  },
];
